exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infoContainer_1uwA- {\n    padding: 0 80px;\n}\n\n.divition_1D8TZ {\n    margin: 10px 0;\n    border-top: 5px solid #040404;\n}\n\n.infoContainer_1uwA- > p {\n    padding: 30px 0 20px 0;\n    font-weight: 800;\n    letter-spacing: 1px;\n    line-height: 25px;\n    font-style: italic;\n}\n\n.infoContainer_1uwA- > h3 {\n    text-align: center;\n    font-weight: 800;\n}\n\n.gapSection4_T_GN2 {\n    height: 670px;\n}\n\n.signatureSize_3kZed img {\n    max-width: 200px;\n    max-height: 80px;\n}\n", ""]);

// exports
exports.locals = {
	"infoContainer": "infoContainer_1uwA-",
	"divition": "divition_1D8TZ",
	"gapSection4": "gapSection4_T_GN2",
	"signatureSize": "signatureSize_3kZed"
};